import { PageController } from '@client/components/_core/layout/PageController';
import { CallLogEdit } from '@client/components/claims/CallLogEdit';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { claimFormStore } from '../store';
import { useClaimInteractionAccess } from '../useClaimInteractionAccess';

export const Route = createFileRoute('/console/$orgId/claims/details/$id/activity/add/phone')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Log call',
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    const { canCreate } = useClaimInteractionAccess();
    const { id } = Route.useParams();
    const record = claimFormStore.use.formData({ throwOnUndefined: false });
    const recordLoaded = record?.id === id;
    const navigate = useNavigate();

    // A pending or stale record is not an access denial.
    useEffect(() => {
        if (recordLoaded && !canCreate) {
            navigate({ moveInMatches: -1 });
        }
    }, [canCreate, recordLoaded]);

    return (
        <PageController route={Route}>{recordLoaded && canCreate && <CallLogEdit action={['add']} />}</PageController>
    );
}
